import { Button, Form } from 'react-bootstrap';

const Pagination = ({ currentPage, totalPages, total, limit, onPageChange, onLimitChange }) => {
  const startIndex = (currentPage - 1) * limit + 1;
  const endIndex = Math.min(currentPage * limit, total);

  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;
    
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
    
    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  };

  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <div className="d-flex align-items-center">
        <span className="me-3">
          Showing {startIndex} to {endIndex} of {total} entries
        </span>
        <Form.Select
          size="sm"
          value={limit}
          onChange={(e) => onLimitChange(parseInt(e.target.value))}
          style={{ width: 'auto' }}
        >
          <option value="10">10 per page</option>
          <option value="20">20 per page</option>
          <option value="50">50 per page</option>
          <option value="100">100 per page</option>
        </Form.Select>
      </div>

      <div className="d-flex align-items-center">
        <Button
          variant="outline-primary"
          size="sm"
          disabled={currentPage === 1}
          onClick={() => onPageChange(1)}
          className="me-1"
        >
          First
        </Button>
        <Button
          variant="outline-primary"
          size="sm"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
          className="me-2"
        >
          Previous
        </Button>

        {getPageNumbers().map(page => (
          <Button
            key={page}
            variant={page === currentPage ? 'primary' : 'outline-primary'}
            size="sm"
            onClick={() => onPageChange(page)}
            className="me-1"
          >
            {page}
          </Button>
        ))}

        <Button
          variant="outline-primary"
          size="sm"
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          className="ms-1 me-1"
        >
          Next
        </Button>
        <Button
          variant="outline-primary"
          size="sm"
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(totalPages)}
        >
          Last
        </Button>
      </div>
    </div>
  );
};

export default Pagination;
